module.exports = __webpack_public_path__ + "static/media/chef.22349f34.png";